export default function getAdminAuthorization(isAdmin, isSelectraAdmin, key) {
  switch (key) {
    case 'home':
    case 'overview':
    case 'form':
    case 'formV2':
    case 'clientCallbacks':
    case 'search':
    case 'logout':
      return true
    case 'users':
      return isAdmin
    case 'ipAddresses':
    case 'assistanceProducts':
    case 'monConseillerPersoProducts':
    case 'carbonOffset':
    case 'servicesStatus':
    case 'providerOptions':
    case 'providers':
    case 'devTools':
    case 'offices':
    case 'teams':
    case 'suppliers':
    case 'websalesUsers':
    case 'additionalSales':
      return isSelectraAdmin
  }
}
